export const validatePassword = (value: string) => /^.{8,999}$/.test(value) && /[0-9]/.test(value) && /[a-z]/.test(value) && /[A-Z]/.test(value)
